import { Center } from '@chakra-ui/react';
import mixpanel from 'mixpanel-browser';
import { useLifecycles, useSearchParam } from 'react-use';

import { PageTitles, UserTrackingEvents } from '@revelio/core';

import DashboardPage from '../DashboardPage';
import { ReportIframe } from './components/report-iframe';

const SampleReportPage = () => {
  const link = useSearchParam('link');
  const sampleLink = link && decodeURIComponent(link);
  const title = [PageTitles.REPORTS_SAMPLE];
  useLifecycles(
    () => {
      mixpanel.track(UserTrackingEvents.PAGE_VISIT, {
        page: title.join('/'),
        sampleLink,
      });
      mixpanel.time_event(UserTrackingEvents.PAGE_LEAVE);
    },
    () => {
      mixpanel.track(UserTrackingEvents.PAGE_LEAVE, {
        page: title.join('/'),
      });
    }
  );

  if (!sampleLink) {
    return (
      <Center h="100%" w="100%">
        Sorry, we could not find this resource.
      </Center>
    );
  }

  return (
    <DashboardPage title={title} loading={false}>
      <ReportIframe link={sampleLink} />
    </DashboardPage>
  );
};

export default SampleReportPage;
